export default {
	title: '采集配置',
	actions: {
		add: '新增',
		edit: '修改',
		copy: '复制',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '名称',
		placeholder: {
			name: '请输入名称'
		}
	},
	table: {
		id: 'ID',
		name: '采集定义名称',
		remark: '采集器类型'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		copy: '复制',
		modelConfig: '模型配置',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		name: '采集定义名称',
		collectorType: '采集器类型',
		highFreqAccel: '高频加速度',
		lowFreqAccel: '低频加速度',
		longWave: '长波形',
		characteristicValue: '特征值',
		collectStrategy: '采集策略',
		configName: '配置名称',
		configValue: '配置值',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			name: '请输入采集定义名称'
		}
	},
	collectorType: {
		singleAxisSensor: '单轴传感器',
		threeAxisSensor: '三轴传感器'
	},
	configItem: {
		collectLength: '采集长度',
		collectFreq: '采集频率',
		collectInterval: '采集间隔',
		zAxisCollectLength: 'Z 轴采集长度',
		xyAxisCollectLength: 'X/Y 轴采集长度',
		zAxisCollectFreq: 'Z 轴采集频率',
		xyAxisCollectFreq: 'X/Y 轴采集频率'
	},
	lengthOptions: {
		'1K': '1K',
		'2K': '2K',
		'4K': '4K',
		'8K': '8K',
		'16K': '16K',
		'32K': '32K',
		'64K': '64K',
		'128K': '128K',
		'256K': '256K',
		'512K': '512K'
	},
	freqOptions: {
		'2560': '2560',
		'5120': '5120',
		'12800': '12800',
		'25600': '25600',
		'51200': '51200'
	},
	intervalOptions: {
		'30': '30',
		'60': '60',
		'300': '300',
		'600': '600',
		'1800': '1800',
		'3600': '3600'
	},
	collectStrategy: {
		speedCollect: '转速采集',
		abnormalEncryptCollect: '异常状态加密采集'
	}
}
